import { Linkedin } from "lucide-react";
import type { HiringContact } from "../api/HiringContactsApi";
import { useHiringContacts } from "../modal/HiringContactsContext";
import AssignEntityModal from "./AssignEntityModal";

interface Props {
  contact: HiringContact;
  onClose: () => void;
}

export default function AssignContactModal({ contact, onClose }: Props) {
  const { contactAssignees, loadContactAssignees, handleAssign, handleUnassign } = useHiringContacts();

  return (
    <AssignEntityModal
      title="Assign Contact"
      subject={
        <>
          <p className="text-sm font-semibold text-foreground font-inter inline-flex items-center gap-1.5">
            {contact.full_name}
            <a href={contact.linkedin_url} target="_blank" rel="noreferrer" className="text-sky-400">
              <Linkedin className="w-3.5 h-3.5" />
            </a>
          </p>
          {contact.role && <p className="text-xs text-muted-foreground font-inter mt-0.5">{contact.role}</p>}
          {contact.company && <p className="text-xs text-muted-foreground font-inter mt-0.5">{contact.company.name}</p>}
        </>
      }
      assignees={contactAssignees}
      onLoadAssignees={() => loadContactAssignees(contact.id)}
      onAssign={(employeeIds) => handleAssign(contact.id, employeeIds)}
      onUnassign={(assignmentId) => handleUnassign(assignmentId, contact.id)}
      onClose={onClose}
    />
  );
}
